export const DEL = "DEL";
export const COL = "COL";